module.exports = __webpack_public_path__ + "static/media/Medi-intro-icon.ef21b9fa.svg";